<template>
  <div>
    <div class="absolute inset-0 flex items-center justify-center">
      <swiper :pagination="{ clickable: true }" loop :autoplay="{ delay: 30000 }" class="w-full h-full">
        <swiper-slide class="grid grid-cols-2 grid-rows-2 disclaimer">
          <div class="relative row-span-full">
            <img src="images/Stocksy_txp8616fcd4VNc100_Medium_967609.jpg" alt="" class="absolute inset-0 object-cover object-right w-full h-full">
          </div>

          <div class="relative grid p-16 space-y-8 text-center text-white place-items-center">
            <div class="absolute inset-0 overflow-hidden">
              <img src="images/1420602380-huge.jpg" srcset="images/1420602380-huge.jpg 1x, images/1420602380-huge@2x.jpg 2x" alt="" class="object-cover w-full h-full">
            </div>
            <div class="relative max-w-md space-y-8 place-items-center">
              <h1 class="text-3xl font-bold uppercase">
                PRIORITY<br>
                LOUNGE
              </h1>
            </div>
          </div>
          <div class="grid p-8 space-y-8 text-center text-white xl:p-16 bg-secondary-500 place-items-center">
            <div class="max-w-sm space-y-2 xl:space-y-4 place-items-center">
              <h1 class="text-3xl font-bold uppercase">
                เอกสิทธิ์เพื่อลูกบ้านคนสำคัญ
              </h1>
              <h2 class="text-xl xl:text-2xl">
                ด้วยบริการห้องรับรองสุดพิเศษ<br>
                ให้คุณและครอบครัวได้ผ่อนคลาย
              </h2>
              <p class="text-sm xl:text-base">
                ด้วยบริการเครื่องดื่ม อาหารว่าง และ Free Wifi<br>
                <strong>ที่ Sales Gallery เซ็นทรัล เฟสติวัล หาดใหญ่</strong>
              </p>
              <p class="text-sm xl:text-base">
                เพียงแสดงสิทธิ์ผ่าน CPN Residence Payment Card*
              </p>
              <p class="text-sm font-bold xl:text-lg">
                หนึ่งในสิทธิประโยชน์พิเศษจาก<br>
                CPN RESIDENCE FAMILY
              </p>
              <div class="absolute bottom-0 right-0 p-4 text-xs">
                *เงื่อนไขเป็นไปตามที่บริษัทฯกำหนด
              </div>
            </div>
          </div>
        </swiper-slide>

        <swiper-slide class="flex items-center justify-center">
          <div class="space-y-4 text-center">
            <img src="@/assets/images/logo-the1.svg" class="w-32 mx-auto" alt="The One">
            <p class="py-8 text-4xl text-secondary-500">
              <strong>สิทธิพิเศษสำหรับลูกบ้านคนสำคัญเช่นคุณ</strong><br>
              รับคะแนน <strong>เซ็นทรัล เดอะวัน x 3</strong> เพิ่มคะแนนเป็น <strong>3 เท่า</strong>
            </p>
            <div class="w-full h-0 max-w-screen-xl border-t border-escent" />
            <p>
              จากทุกค่าใช้จ่ายการจอง การทำสัญญา และการผ่อนดาวน์ทุกงวด ทุกโครงการจาก CPN Residence<br>
              (ยอดการใช้จ่าย 25 บาท รับคะแนน เซ็นทรัล เดอะวัน 3 คะแนน จากปกติ 1 คะแนน)<br>
              ให้คุณเปลี่ยนคะแนนสะสมเป็นส่วนลดสำหรับทุกการใช้จ่าย*<br>
              <span class="text-2xl font-bold text-secondary-500">หนึ่งในสิทธิประโยชน์พิเศษจาก CPN RESIDENCE Family</span>
            </p>
            <div class="w-full h-0 max-w-screen-xl border-t border-escent" />
          </div>
          <div class="absolute top-0 left-0 p-12 py-16 text-3xl font-bold text-center text-white xl:p-16 xl:py-24 w-96 bg-secondary-500">
            CPN RESIDENCE PRIVILEGE
          </div>
          <div class="absolute bottom-0 right-0 p-4 text-xs">
            *เงื่อนไขเป็นไปตามที่บริษัทฯกำหนด
          </div>
        </swiper-slide>

        <swiper-slide class="relative">
          <div class="absolute inset-0">
            <img src="@/assets/images/bg-gradient-gold.svg" class="w-full h-full" alt="">
          </div>
          <div class="absolute inset-0 flex items-center justify-center">
            <div class="grid flex-1 w-full h-full grid-cols-2 grid-rows-3">
              <div class="col-span-2">
                <img src="images/shutterstock_1255287592.jpg" class="object-cover w-full h-full" alt="">
              </div>
              <div class="relative flex flex-col items-center justify-center col-span-2">
                <div class="absolute inset-0">
                  <img src="@/assets/images/bg-gradient-gold2.svg" class="w-full h-full" alt="">
                </div>
                <div class="relative text-lg text-center 2xl:text-2xl">
                  <p class="leading-relaxed">
                    ให้คุณคนสำคัญ ได้รับอภิสิทธิ์เหนือใคร..<br>
                    ไม่ว่าจะเป็นส่วนลด หรือสิทธิประโยชน์ต่างๆ<br>
                    จาก Partner ทั้งในเครือ Central Group และแบรนด์ชั้นนำ
                  </p>
                  <p class="inline-flex items-center justify-center h-12 mt-4 space-x-6">
                    <img src="@/assets/images/logo-central.svg" class="h-full" alt="">
                    <img src="@/assets/images/logo-robinson.svg" class="h-full" alt="">
                    <img src="@/assets/images/logo-tops-online.svg" class="h-full" alt="">
                    <img src="@/assets/images/logo-vfix.svg" class="h-full" alt="">
                    <img src="@/assets/images/logo-thai-smile.svg" class="h-full" alt="">
                  </p>
                </div>
              </div>
              <div class="">
                <img src="images/yousef-alfuhigi-bMIlyKZHKMY-unsplash.jpg" class="object-cover w-full h-full" alt="">
              </div>
              <div class="">
                <img src="images/shutterstock_1793783119.jpg" class="object-cover w-full h-full" alt="">
              </div>
            </div>
            <div class="flex-shrink-0 w-2/6 p-8 space-y-8 text-center text-white 2xl:space-y-12 2xl:p-16" style="filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5));">
              <h1 class="text-3xl font-bold leading-normal 2xl:text-5xl">
                CPN RESIDENCE PRIVILEGE
              </h1>
              <div class="w-full h-0 max-w-screen-xl border-t border-secondary-200" />
              <p class="text-lg 2xl:text-2xl">
                อีกหนึ่งสิทธิพิเศษที่ได้มากยิ่งกว่า..<br>
                คัดสรรมาให้เฉพาะ<br>
                ลูกบ้าน CPN RESIDENCE เท่านั้น
              </p>
              <div class="w-full h-0 max-w-screen-xl border-t border-secondary-200" />
              <p class="text-lg 2xl:text-2xl">
                สามารถติดตาม Privilege เพิ่มเติมได้ที่<br>
                <strong>CPN RESIDENCE FAMILY Application</strong>
              </p>
              <div class="flex justify-between">
                <img src="@/assets/images/logo-cpn-residence-family-app.svg" class="w-20 h-20 2xl:w-32 2xl:h-32" alt="">
                <div class="space-y-4">
                  <img src="@/assets/images/qr-app-store.svg" class="w-20 h-20 2xl:w-32 2xl:h-32" alt="">
                  <img src="@/assets/images/app-store.svg" class="w-20 2xl:w-32" alt="">
                </div>
                <div class="space-y-4">
                  <img src="@/assets/images/qr-google-play.svg" class="w-20 h-20 2xl:w-32 2xl:h-32" alt="">
                  <img src="@/assets/images/google-play.svg" class="w-20 2xl:w-32" alt="">
                </div>
              </div>
            </div>
            <div class="absolute bottom-0 right-0 p-4 text-xs text-white">
              *เงื่อนไขเป็นไปตามที่บริษัทฯกำหนด
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Pagination, Autoplay, Lazy } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

SwiperCore.use([
  Pagination,
  Autoplay,
  Lazy,
])

export default {
  name: 'Privileges',
  components: {
    Swiper,
    SwiperSlide,
  },
}
</script>
